import Button from '../../../components/base/Button';

export default function FinalCTASection() {
  const handleCallClick = () => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'clic_pulsante_chiamata'
      });
    }
  };

  return (
    <section className="relative py-16 md:py-24 lg:py-32 bg-gradient-to-br from-[#2563eb] to-[#1e40af] overflow-hidden">
      <style>{`
        @keyframes cta-pulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
          }
        }
      `}</style>
      <div className="absolute top-0 right-0 w-64 h-64 md:w-96 md:h-96 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 md:w-80 md:h-80 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2"></div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10 space-y-8 md:space-y-12 px-4">
        <div className="space-y-4 md:space-y-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-white">
            Scopri come smettere di sprecare budget
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-blue-100 max-w-2xl mx-auto">
            Prenota la tua call. Ti mostro Landing Page reali che ho sviluppato e come hanno aumentato concretamente i contatti dalle Ads, anche partendo da campagne che non convertivano.
          </p>
        </div>
        
        <div className="flex justify-center">
          <button
            onClick={handleCallClick}
            data-cal-link="andrea-disanto-0kedbr/30min"
            data-cal-namespace="30min"
            data-cal-config='{"layout":"month_view"}'
            className="whitespace-nowrap font-medium transition-all duration-300 cursor-pointer border-2 bg-white text-[#000000] border-[#000000] hover:bg-[#000000] hover:text-white hover:border-[#000000] px-8 py-4 text-base md:text-lg md:px-10 md:py-5"
            style={{ animation: 'cta-pulse 2s ease-in-out infinite' }}
          >
            Prenota una Call di 30 min.
          </button>
        </div>
      </div>
    </section>
  );
}
